import { useCallback, useEffect, useRef, useState } from 'react';
import { useSpring } from 'react-spring';
import { useOnMount } from 'src/shared/hooks/useOnMount';
import { useUnmount } from 'src/shared/hooks/useUnmount';
import { Transition } from 'web-common/src/shared/styles';
import { PROGRESS_BAR_MOUNT_BUFFER } from '../consts';

export const useAnimatedNumber = (number: number) => {
  const [previousNumber, setPreviousNumber] = useState(number - PROGRESS_BAR_MOUNT_BUFFER);
  const animatedNumber = useSpring({
    val: number,
    from: { val: previousNumber },
    config: { duration: Transition.TimeValue.DOUBLE },
  });

  useEffect(() => setPreviousNumber(number - PROGRESS_BAR_MOUNT_BUFFER), [number]);

  return animatedNumber;
};

export const useAnimatedNumberWithAnimatedState = (number: number) => {
  const [previousNumber, setPreviousNumber] = useState(number - PROGRESS_BAR_MOUNT_BUFFER);
  const [isAnimating, setIsAnimating] = useState(false);
  const isAnimatingRef = useRef(false);
  const animatedNumber = useSpring({
    val: number,
    from: { val: previousNumber },
    config: { duration: Transition.TimeValue.DOUBLE },
    onStart: useCallback(() => {
      if (isAnimatingRef.current) {
        setIsAnimating(true);
      }
    }, []),
    onRest: useCallback(() => {
      if (isAnimatingRef.current) {
        setIsAnimating(false);
      }
    }, []),
  });

  useEffect(() => setPreviousNumber(number - PROGRESS_BAR_MOUNT_BUFFER), [number]);

  useOnMount(() => {
    // eslint-disable-next-line functional/immutable-data -- Setting ref
    isAnimatingRef.current = true;
  });

  useUnmount(() => {
    // eslint-disable-next-line functional/immutable-data -- Setting ref
    isAnimatingRef.current = false;
  });

  return { animatedNumber, isAnimating };
};
